import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const BrutalistCard = styled.div`
  width: 320px;
  border: 4px solid #000;
  background-color: #fff;
  padding: 1.5rem;
  box-shadow: 10px 10px 0 #000;
  font-family: "Arial", sans-serif;
`;

const BrutalistCardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  border-bottom: 2px solid #000;
  padding-bottom: 1rem;
`;

const BrutalistCardIcon = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000;
  padding: 0.5rem;
  
  svg {
    height: 1.5rem;
    width: 1.5rem;
    fill: #fff;
  }
`;

const BrutalistCardAlert = styled.div`
  font-weight: 900;
  color: #000;
  font-size: 1.5rem;
  text-transform: uppercase;
`;

const BrutalistCardMessage = styled.div`
  margin-top: 1rem;
  color: #000;
  font-size: 0.9rem;
  line-height: 1.4;
  border-bottom: 2px solid #000;
  padding-bottom: 1rem;
  font-weight: 600;
`;

const BrutalistCardActions = styled.div`
  margin-top: 1rem;
`;

const BrutalistCardButton = styled.button<{ $variant?: 'accept' | 'decline' }>`
  display: block;
  width: 100%;
  padding: 0.75rem;
  text-align: center;
  font-size: 1rem;
  font-weight: 700;
  text-transform: uppercase;
  border: 3px solid #000;
  background-color: ${props => props.$variant === 'accept' ? '#000' : '#fff'};
  color: ${props => props.$variant === 'accept' ? '#fff' : '#000'};
  position: relative;
  transition: all 0.2s ease;
  box-shadow: 5px 5px 0 #000;
  overflow: hidden;
  text-decoration: none;
  margin-bottom: 1rem;
  cursor: pointer;
  
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      120deg,
      transparent,
      rgba(255, 255, 255, 0.3),
      transparent
    );
    transition: all 0.6s;
  }
  
  &:hover::before {
    left: 100%;
  }
  
  &:hover {
    transform: translate(-2px, -2px);
    box-shadow: 7px 7px 0 #000;
  }
  
  &:hover {
    background-color: ${props => props.$variant === 'accept' ? '#296fbb' : '#ff0000'};
    border-color: ${props => props.$variant === 'accept' ? '#296fbb' : '#ff0000'};
    color: #fff;
    box-shadow: 7px 7px 0 ${props => props.$variant === 'accept' ? '#004280' : '#800000'};
  }
  
  &:active {
    transform: translate(5px, 5px);
    box-shadow: none;
  }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
`;

interface CookieConsentProps {
  onAccept: () => void;
  onDecline: () => void;
}

const CookieConsent: React.FC<CookieConsentProps> = ({ onAccept, onDecline }) => {
  return (
    <Overlay>
      <BrutalistCard>
        <BrutalistCardHeader>
          <BrutalistCardIcon>
            <svg viewBox="0 0 24 24">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
            </svg>
          </BrutalistCardIcon>
          <BrutalistCardAlert>Cookies</BrutalistCardAlert>
        </BrutalistCardHeader>
        
        <BrutalistCardMessage>
          We use cookies to enhance your experience and analyze our traffic. By clicking "Accept All", you consent to our use of cookies.
        </BrutalistCardMessage>
        
        <BrutalistCardActions>
          <BrutalistCardButton $variant="accept" onClick={onAccept}>
            Accept All
          </BrutalistCardButton>
          <BrutalistCardButton $variant="decline" onClick={onDecline}>
            Decline
          </BrutalistCardButton>
        </BrutalistCardActions>
      </BrutalistCard>
    </Overlay>
  );
};

export default CookieConsent;
